import { render, staticRenderFns } from "./HighlightLabelMaker.vue?vue&type=template&id=12e4d49b&scoped=true"
import script from "./HighlightLabelMaker.vue?vue&type=script&lang=js"
export * from "./HighlightLabelMaker.vue?vue&type=script&lang=js"
import style0 from "./HighlightLabelMaker.vue?vue&type=style&index=0&id=12e4d49b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e4d49b",
  null
  
)

export default component.exports